function initRelated(){
    "use strict";
    $('.related-news .carousel').slick({
		dots: false,
		arrows: false,
		nav: false,
		infinite: false,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [
						 {
				breakpoint: 800,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					dots: false,
					centerMode: true,
					centerPadding: '150px'
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					 infinite: true,
					centerPadding: '100px'
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: false,
					infinite: true
				}
			}
		]
	});
	setTimeout(function(){
		$(window).trigger('resize');	
	},500);
}